import {Box, Button, CircularProgress, IconButton, Stack} from "@mui/material";
import {useEffect, useState} from "react";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";
import {scopeToString} from "../utils/formatData";
import ScopeForm from "../components/Scopes/ScopeForm";
import ScopeInfo from "../components/Scopes/ScopeInfo";
import ScopeRolesList from "../components/Scopes/ScopeRolesList";
import Window from "../components/Window/Window";
import useApiRequest from "../hooks/useApiRequest";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import useConfirmDialog from "../hooks/useConfirmDialog";
import {useAuthPermissions, ACTIONS, RESOURCES} from "../hooks/useAuthPermissions";
import {snackbar} from "../utils/snackbar";

const ScopeDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const id = state?.id;

  const isNewScope = !id;

  const {data, loading, read, remove} = useApiRequest({baseUrl: "/scopes", resource: "scopes"});

  const [isEditing, setIsEditing] = useState(isNewScope);
  const {can} = useAuthPermissions();

  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async () => {
    const {success} = await remove(id);
    if (!success) return;

    snackbar.success("Scope eliminado correctamente.");
    navigate("/scopes");
  });

  useEffect(() => {
    if (!isNewScope) {
      read(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const scopeData = data && !data.resource && data.data ? data.data : data;

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleOpenDeleteDialog = () => {
    openDialog(id, scopeToString(scopeData));
  };

  return (
    <Window title={isNewScope ? "Nuevo Scope" : `Scope: ${scopeToString(scopeData)}`} backTo="/scopes">
      {loading && !isNewScope ? (
        <CircularProgress />
      ) : (
        <>
          <Stack direction="row" spacing={2} justifyContent={"space-between"}>
            {isEditing ? (
              <ScopeForm
                isNew={isNewScope}
                refreshData={() => read(id)}
                setIsEditing={setIsEditing}
                initialScopeData={scopeData || {}}
              />
            ) : (
              <ScopeInfo scope={scopeData} />
            )}
            <Box>
              {!isNewScope &&
                can(ACTIONS.WRITE, RESOURCES.SCOPES) &&
                (isEditing ? (
                  <Button variant="contained" color="primary" onClick={handleEditToggle}>
                    Cancelar
                  </Button>
                ) : (
                  <IconButton aria-label="edit" color="primary" onClick={handleEditToggle}>
                    <FiEdit2 />
                  </IconButton>
                ))}
              {!isNewScope && can(ACTIONS.DELETE, RESOURCES.SCOPES) && (
                <IconButton aria-label="delete" color="secondary" onClick={handleOpenDeleteDialog}>
                  <FiTrash2 />
                </IconButton>
              )}
            </Box>
          </Stack>
          {!isNewScope && !isEditing && <ScopeRolesList scopeId={id} />}
        </>
      )}
      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="scope"
        entityLabel={itemName}
      />
    </Window>
  );
};

export default ScopeDetail;
